import { Component, EventEmitter, inject, OnInit, Output, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
// import { getSessionId } from '../../../helpers/storageUtils';
import { AdvisorService } from '../../../services/advisor/advisor.service';
// import { TokenService } from '../../services/token.service';
// import { GeneralService } from '../../services/general.service';
// import { StorageService } from '../../services/storage.service';
import { AuthService } from '@app/services/auth/auth.service';
import { Store } from '@ngrx/store';
import { setData } from 'src/storage/general.actions';
import { NgClass } from "../../../../../node_modules/@angular/common/index";



interface Asesor {
  'Nombre-cod': string;
  Cod: string;
  Nombre: string;
}

@Component({
  selector: 'app-advisor-form',
  standalone: true,
  imports: [
    ReactiveFormsModule, // Para formularios reactivos
    FormsModule,
    NgClass
],
  templateUrl: './advisor-form.component.html',
  styleUrl: './advisor-form.component.scss'
})
export class AdvisorFormComponent implements OnInit {
  advisorForm!: FormGroup;
  withAssistance = signal(false);
  showError = signal(false);
  isInvalidAdvisor = signal(false);
  // TokenService = inject(TokenService);
  private generalService = inject(AuthService);

  advisorControl = new FormControl('');
  filteredAdvisors: Asesor[] = [];
  showErrorMessage = signal<string>('Debes ingresar el nombre o código del asesor.')

  private route = inject(ActivatedRoute);
  private advisorService = inject(AdvisorService);
  private destroy$ = new Subject<void>();
  private storageService = inject(Store);


  @Output() isValid = new EventEmitter<boolean>(true);
  @Output() advisorSelected = new EventEmitter<any>();

  asesores: Asesor[] = [];
  sessionId: any;


  constructor(private fb: FormBuilder) {

    this.sessionId = localStorage.getItem('session_id') || '';

    

  }

  ngOnInit(): void {

    this.advisorForm = this.fb.group({
      assistance: ['no', Validators.required],
      advisor: this.advisorControl
    });

    this.advisorForm.valueChanges.subscribe(() => {
      this.validateForm();
    });

    this.advisorControl.valueChanges.subscribe(value => {
    
      this.isInvalidAdvisor.set(false);
      this.showError.set(false);
    
      const query = value?.toLowerCase() || '';
    
      if (query === '') {
        this.filteredAdvisors = [];
        this.showError.set(true);
        this.showErrorMessage.set('Debes ingresar el nombre o código del asesor.')
        this.advisorForm.get('advisor')?.setErrors({ required: true });
        return;
      }

      this.filteredAdvisors = this.asesores.filter(asesor =>
        asesor['Nombre-cod'].toLowerCase().includes(query)
      );
    });

    this.generalService.isTokenValid().subscribe((token) => {
      if (token) {
        this.route.queryParams
          .pipe(takeUntil(this.destroy$))
          .subscribe((params) => {
            const codAsesor = params['codigoAsesor'] || '';
            if (codAsesor) {
              this.loadAdvisorData(codAsesor);
            }

            if (!codAsesor) {
              this.getAdvisorList(this.sessionId);
            }
          });
      }
    });


    this.isValid.emit(true)


  }

  private loadAdvisorData(codAsesor: string): void {

    this.advisorService.getAdvisorInformation(this.sessionId, codAsesor)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

        const { data, error } = response;
        if (data && data.Asesor && data.Asesor.length > 0) {

          const asesor = data.Asesor[0];

          //Setear el código del asesor en el store de rxjs para las próximas pantallas.

          this.storageService.dispatch(setData({
            key: 'codigoAsesor',
            value: asesor['Cod'],
            merge: false,
          }));

          //Setear el asesor y código de asesor en el campo del formulario

          this.advisorControl.setValue(asesor['Nombre-cod']);
          this.advisorForm.patchValue({ advisor: asesor['Nombre-cod'], assistance: 'si' });
          this.advisorForm.markAllAsTouched();
          this.withAssistance.set(true);
          this.advisorForm.get('assistance')?.setValue('si');
          this.advisorForm.get('assistance')?.disable();
          this.advisorForm.get('advisor')?.disable();
          this.isInvalidAdvisor.set(false);
          this.isValid.emit(true);
          this.advisorSelected.emit(asesor);
        }

        if (error === 'No existen asesores activos' || !data.Asesor || data.Asesor.length === 0) {

          this.withAssistance.set(true);
          this.advisorForm.get('assistance')?.setValue('si');
          this.advisorForm.patchValue({ advisor: '' });
          this.isInvalidAdvisor.set(true);
          this.showErrorMessage.set('No encontramos asesor. Verifica nombre o código.');
          this.showError.set(true);
          this.isValid.emit(false);
          this.advisorSelected.emit('');
          this.getAdvisorList(this.sessionId);
        }
      });
  }

  private validateForm(): void {
    const assistance = this.advisorForm.get('assistance')?.value;
    const advisor = this.advisorControl.value?.trim();

    if (assistance === 'si') {

      const isAdvisorValid = !!advisor && advisor.length > 0;
      this.withAssistance.set(true);
      this.isValid.emit(isAdvisorValid);
      this.advisorSelected.emit(advisor);

      return;
    }

    if (assistance === 'no') {
      this.showError.set(false);
      this.isValid.emit(true);
      this.advisorControl.setValue('', { emitEvent: false });
      this.filteredAdvisors = [];
      this.withAssistance.set(false);
      return;
    }


    // this.showError.set(false);
    this.isValid.emit(false);

  }



  selectAdvisor(asesor: Asesor): void {
    //Setear el Nombre del asesor más el código del asesor en el campo del formulario.
    this.advisorControl.setValue(asesor['Nombre-cod']);

    //Setear el código del asesor en el store de rxjs para las próximas pantallas.
    this.storageService.dispatch(setData({
      key: 'codigoAsesor',
      value: asesor['Cod'],
      merge: false,
    }));


    this.filteredAdvisors = [];
    this.validateForm();
    this.advisorSelected.emit(asesor);
    this.showError.set(false);
  }


  private getAdvisorList(sessionId: string,): void {
    this.advisorService.getAdvisorsList(sessionId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        console.log('response getAdvisorList', response);

        const { data } = response;
        const { Asesores, error } = data || {};
        if (data && Asesores) {
          this.asesores = Asesores;
        }
      });
  }

  onBlur(): void {
    setTimeout(() => {
      this.filteredAdvisors = [];
      this.showError.set(false)
    }, 200); // Retardo para permitir la selección antes de ocultar
  }
}
